import { TokenLoginPageComponent } from './token-login-page.component';
import { AuthenticateTokenModule } from './authenticateToken/authenticate-token.module';
export const TokenLoginPageModule = angular
    .module('tokenLoginPage', [AuthenticateTokenModule])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('authenticateToken', {
            url: '/authenticateToken?a&t&cid&comp',
            params: {
                a: null,
                t: null,
                cid: null,
                comp: null
            },
            component: TokenLoginPageComponent.selector,
            data: {
                requireLogin: false
            }
        });
    }
])
    .component(TokenLoginPageComponent.selector, TokenLoginPageComponent.component)
    .name;
//# sourceMappingURL=token-login-page.module.js.map